
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const Features = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const item = {
    hidden: { 
      opacity: 0, 
      y: 20,
      scale: 0.95
    },
    show: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10
      }
    }
  };

  const glowVariants = {
    initial: { opacity: 0.5 },
    animate: {
      opacity: [0.5, 1, 0.5],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="w-full px-4 mb-20"
    >
      <motion.div className="text-center mb-8">
        <motion.span 
          className="text-flux-cyan text-xl cursor-default"
          whileHover={{ scale: 1.05 }}
        >
          What is <span className="text-flux-cyan font-bold">Flux</span><span className="font-bold text-flux-cyan">Void</span>?
        </motion.span>
      </motion.div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <Link to="/features/startup-recruitment">
          <motion.div
            variants={item}
            whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
            className="relative p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl h-full
                     hover:border-[#00F0FF] hover:bg-gradient-to-r hover:from-[#00F0FF]/10 hover:to-[#0EA5E9]/10 
                     transition-all duration-300 group"
          >
            <motion.div
              variants={glowVariants}
              animate="animate"
              className="absolute inset-0 bg-gradient-to-r from-flux-cyan/5 via-flux-blue/5 to-flux-purple/5 rounded-xl"
            />
            <div className="relative z-10">
              <h3 className="text-flux-cyan text-xl font-semibold mb-3 group-hover:text-white transition-colors">
                Startup Network
              </h3>
              <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
                Recruit the perfect team of like-minded individuals for your venture.
              </p>
            </div>
          </motion.div>
        </Link>

        <Link to="/features/vesu-ai">
          <motion.div
            variants={item}
            whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
            className="relative p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl h-full
                     hover:border-[#00F0FF] hover:bg-gradient-to-r hover:from-[#00F0FF]/10 hover:to-[#0EA5E9]/10 
                     transition-all duration-300 group"
          >
            <motion.div
              variants={glowVariants}
              animate="animate"
              className="absolute inset-0 bg-gradient-to-r from-flux-blue/5 via-flux-purple/5 to-flux-cyan/5 rounded-xl"
            />
            <div className="relative z-10">
              <h3 className="text-flux-cyan text-xl font-semibold mb-3 group-hover:text-white transition-colors">
                Vesu AI
              </h3>
              <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
                Get the perfect starting point with VesuStart. Empowering small businesses and tech startups.
              </p>
            </div>
          </motion.div>
        </Link>

        <Link to="/features/creative-freedom">
          <motion.div
            variants={item}
            whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
            className="relative p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl h-full
                     hover:border-[#00F0FF] hover:bg-gradient-to-r hover:from-[#00F0FF]/10 hover:to-[#0EA5E9]/10 
                     transition-all duration-300 group"
          >
            <motion.div
              variants={glowVariants}
              animate="animate"
              className="absolute inset-0 bg-gradient-to-r from-flux-purple/5 via-flux-cyan/5 to-flux-blue/5 rounded-xl"
            />
            <div className="relative z-10">
              <h3 className="text-flux-cyan text-xl font-semibold mb-3 group-hover:text-white transition-colors">
                Collaboration Hub
              </h3>
              <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
                Gamified platform for connecting, sharing ideas, and building together in real-time.
              </p>
            </div>
          </motion.div>
        </Link>
      </div>
    </motion.div>
  );
};
